import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AllLoans from './pages/AllLoans';
import LoanDetails from './pages/LoanDetails';
import Borrowers from './pages/Borrowers';
import CreateBorrower from './pages/CreateBorrower';
import BorrowerDetails from './pages/BorrowerDetails';
import Profitability from './pages/Profitability';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Support from './pages/Support';
import CreateLoan from './pages/CreateLoan';
import Profile from './pages/Profile';
import Collateral from './pages/Collateral';
import CreatePledge from './pages/CreatePledge';
import PledgeDetails from './pages/PledgeDetails';
import { isTokenExpired, handleTokenExpire } from './services/api';
import './App.css';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (isTokenExpired(token)) {
    handleTokenExpire();
    return null;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/loans" element={
              <ProtectedRoute>
                <AllLoans />
              </ProtectedRoute>
            } />
            <Route path="/loans/:loanId" element={
              <ProtectedRoute>
                <LoanDetails />
              </ProtectedRoute>
            } />
            <Route path="/borrowers" element={
              <ProtectedRoute>
                <Borrowers />
              </ProtectedRoute>
            } />
            <Route path="/borrowers/create" element={
              <ProtectedRoute>
                <CreateBorrower />
              </ProtectedRoute>
            } />
            <Route path="/borrowers/:borrowerId" element={
              <ProtectedRoute>
                <BorrowerDetails />
              </ProtectedRoute>
            } />
            <Route path="/profitability" element={
              <ProtectedRoute>
                <Profitability />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/support" element={
              <ProtectedRoute>
                <Support />
              </ProtectedRoute>
            } />
            <Route path="/create-loan" element={
              <ProtectedRoute>
                <CreateLoan />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/collateral" element={
              <ProtectedRoute>
                <Collateral />
              </ProtectedRoute>
            } />
            <Route path="/collateral/create" element={
              <ProtectedRoute>
                <CreatePledge />
              </ProtectedRoute>
            } />
            <Route path="/pledges/:pledgeId" element={
              <ProtectedRoute>
                <PledgeDetails />
              </ProtectedRoute>
            } />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;